<template>
	<vx-card v-if="companyData" id="company-card-main">
		<div slot="no-body" class="tabs-container px-6 pt-6">
			<vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
				<vs-tab :label="$t('ListOfCompanies')" icon-pack="feather" icon="icon-list">
					<div class="tab-text">
						<company-list-view-card
							class="mt-4"
							:data="companyData"
							@selectedCompanyEmit="selectedCompanyEmit"
							@selectedCompanyCreateAdminResourceEmit="selectedCompanyCreateAdminResource"
						/>
					</div>
				</vs-tab>

				<vs-tab :label="tabLabelText" icon-pack="feather" icon="icon-plus-square">
					<div class="tab-text overflow-tab-content">
						<form-wizard
							color="rgba(var(--vs-primary), 1)"
							errorColor="rgba(var(--vs-danger), 1)"
							:title="null"
							:subtitle="null"
							:finishButton="false"
							finishButtonText="Finalizar"
							:backButtonText="prevButtonText"
							:nextButtonText="nextButtonText"
							@on-change="handleChange"
						>
							<!-- tab 1 content -->
							<tab-content
								v-if="mode === 'create' || mode === 'update'"
								:title="$t('CompanyModule.CompanyInformation')"
								class="mb-5"
								icon="feather icon-briefcase"
								:before-change="validateStep1"
							>
								<form data-vv-scope="step-1">
									<company-form
										:data="company"
										:isEditActive="isEditActive"
										@changeActiveTabEmit="changeActiveTab"
										@getFormDataCompanyEmit="getFormDataCompany"
										ref="CompanyForm"
									/>
								</form>
							</tab-content>

							<!-- tab 2 content -->
							<tab-content
								v-if="mode === 'create' || mode === 'createAdmin'"
								:title="$t('CompanyModule.AdminResource')"
								class="mb-5"
								icon="feather icon-user"
								:before-change="validateStep2"
							>
								<form data-vv-scope="step-2">
									<first-resource-form
										@getFormDataResourceEmit="getFormDataResource"
										ref="FirstResourceForm"
									/>
								</form>
							</tab-content>

							<!-- tab 3 content -->
							<tab-content
								v-if="mode === 'create' || mode === 'createAdmin'"
								:title="$t('CompanyModule.Summary')"
								class="mb-5"
								icon="feather icon-layout"
								:before-change="validateStep3"
							>
								<form data-vv-scope="step-3">
									<company-resum-create
										:company="company"
										:resource="resource.resource ? resource.resource : {}"
										:mode="mode"
									/>
								</form>
							</tab-content>

							<!-- tab 4 content -->
							<tab-content
								v-if="mode === 'create' || mode === 'createAdmin'"
								:title="$t('CompanyModule.Finish')"
								class="mb-5"
								icon="feather icon-send"
								:before-change="validateStep4"
							>
								<vx-card no-shadow card-border>
									<form data-vv-scope="step-4">
										<h4>{{ $t("Company") }}:</h4>
										<p class="text-success" v-if="companyStatus === true">
											{{ $t("TextConfirmCompanyCreate") }}
										</p>

										<h4 class="mt-5">{{ $t("CompanyModule.AdminResource") }}:</h4>
										<p class="mb-5 text-success" v-if="resourceStatus === true">
											{{ $t("CompanyModule.AdminResourceSuccess") }}
										</p>
										<p class="mb-5" v-if="resourceStatus === false">
											{{ $t("CompanyModule.AdminResourceError") }}
										</p>
										<p class="mb-5 text-danger" v-if="resourceStatus === false">
											{{ $t("CompanyModule.AdminResourceFailed") }}
										</p>

										<a
											v-if="resourceStatus !== null"
											href="#"
											class="mt-5 text-inherit underline cursor-pointer"
											@click="activeTab = 0"
											color="success"
											>{{ $t("CompanyModule.ViewCompanyList") }}</a
										>

										<h4 class="mt-5">{{ $t("CompanyModule.RequiredConfig") }}:</h4>
										<p v-if="companyStatus !== null && resourceStatus !== null">
											<vs-icon icon="warning_amber" size="22px" color="#ff9f43"></vs-icon>
											{{ $t("CompanyModule.ActivateSitidadaText1") }}

											<router-link
												:to="{
													name: 'app-setting',
													params: {company_id: resultCompanyId, config_type: 'SITIDATA'},
												}"
												class="text-inherit underline"
												>{{ $t("CompanyModule.ActivateSitidadaText2") }}</router-link
											>
										</p>
									</form>
								</vx-card>
							</tab-content>
							<template slot="next">
								<vs-button color="primary">{{ nextButtonText }}</vs-button>
							</template>

							<template slot="prev">
								<vs-button color="primary" v-show="disbableBottonPrev">{{ prevButtonText }}</vs-button>
							</template>

							<template slot="finish">
								<vs-button color="primary" class="mr-2" v-show="mode === 'update'" @click="updateData"
									>{{ $t("Crud.Update") }}
								</vs-button>
							</template>
						</form-wizard>
					</div>
				</vs-tab>
			</vs-tabs>
		</div>
	</vx-card>
</template>
<script>
import {FormWizard, TabContent} from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import CompanyForm from "./CompanyForm.vue";
import Company from "@/models/Company.js";
import CompanyListView from "./CompanyListView.vue";
import FirstResourceForm from "./FirstResourceForm.vue";
import moduleCompany from "@/store/company/moduleCompany.js";
import moduleResource from "@/store/resource/moduleResource.js";
import CompanyResumCreate from "./CompanyResumCreate.vue";
import CompanyListViewCard from "./CompanyListViewCard.vue";
import DateUtils from "@/helpers/DateUtils.js";

export default {
	name: "Company",
	data() {
		return {
			company: new Company({}),
			resource: {},
			companyData: {},
			activeTab: 0,
			isEditActive: false,
			disbableBottonPrev: true,
			activeAlert: true,
			nextButtonI18: this.$t("ResourceModule.Create.Next"),
			preButtonI18: this.$t("ResourceModule.Create.Previous"),
			resourceStatus: null,
			companyStatus: null,
			mode: "create",
			resultCompanyId: 0,
			resultResourceId: 0,
		};
	},
	components: {
		CompanyForm,
		CompanyListView,
		FormWizard,
		TabContent,
		FirstResourceForm,
		CompanyResumCreate,
		CompanyListViewCard,
	},
	computed: {
		tabLabelText() {
			if (this.company.id > 0 && this.activeTab === 1) {
				this.isEditActive = true;
				return this.$t("UpdateCompany");
			} else {
				this.isEditActive = false;
				return this.$t("NewCompany");
			}
		},
		nextButtonText: {
			get() {
				return this.$t(this.nextButtonI18);
			},
			set(val) {
				this.nextButtonI18 = val;
			},
		},
		prevButtonText: {
			get() {
				return this.$t(this.preButtonI18);
			},
			set(val) {
				this.preButtonI18 = val;
			},
		},
	},
	methods: {
		goTo(path) {
			this.$router.push(path);
		},
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		formatDates(dateString) {
			// 'Tue, 18 Mar 2025 19:35:52 GMT'
			const newDate = new Date(dateString);
			return DateUtils.toDefaultDateTime(newDate, "YYYY-MM-DD HH:mm:ss");
		},
		createCompany() {
			this.company.date_init = this.formatDates(this.company.date_init);
			this.company.date_end = this.formatDates(this.company.date_end);
			delete this.company.id;
			this.openLoading();
			this.$store
				.dispatch("moduleCompany/addItemCompany", this.company)
				.then((res) => {
					if (res.data.id) this.companyStatus = true;
					this.resultCompanyId = res.data.id;
					delete this.resource.id;
					return this.$store.dispatch("moduleResource/addResource", {
						...this.resource.resource,
						company_id: this.company.id,
						role_id: res.data.admin_role_id,
					});
				})
				.then((res) => {
					if (res.data.id) this.resourceStatus = true;
					this.resultResourceId = res.data.id;
					this.$vs.notify({
						color: "success",
						title: this.$t("TitleConfirmCompanyCreate"),
						text: this.$t("TextConfirmCompanyCreate"),
					});
					this.closeLoading();
				})
				.catch((err) => {
					this.resourceStatus = false;
					console.error(err);
					this.closeLoading();
				});
		},
		createAdminResource() {
			delete this.resource.id;
			this.openLoading();
			this.$store
				.dispatch("moduleResource/addResource", {
					...this.resource.resource,
					company_id: this.company.id,
					role_id: this.company.admin_role_id,
				})
				.then((res) => {
					this.resourceStatus = true;
					this.closeLoading();
					this.$vs.notify({
						color: "success",
						title: this.$t("Resource.Create.Success.Title"),
						text: this.$t("Resource.Create.Success.Text"),
					});
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
				});
		},
		updateData() {
			this.company.date_init = this.formatDates(this.company.date_init);
			this.company.date_end = this.formatDates(this.company.date_end);

			this.openLoading();
			this.$store
				.dispatch("moduleCompany/updateItem", this.company)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("TitleConfirmCompanyUpdate"),
						text: this.$t("TextConfirmCompanyUpdate"),
					});
					this.closeLoading();
					this.activeTab = 0;
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
				});
		},
		createSitidata() {
			this.$router
				.push({name: "app-setting", params: {company_id: this.resultCompanyId, config_type: "SITIDATA"}})
				.catch(() => {});
		},
		selectedCompanyEmit(company, createAdmin) {
			this.company = new Company(company);
			this.mode = createAdmin;
			this.activeTab = 1;
		},
		selectedCompanyCreateAdminResource(company, createAdmin) {
			this.company = new Company(company);
			// Agregamos al objeto company los nuevos atributos capturados desde el listado para agregar al body del recurso
			this.company.resource_typology_id = company.resource_typology_id;
			this.company.admin_role_id = company.admin_role_id;
			this.mode = createAdmin;
			this.activeTab = 1;
		},
		changeActiveTab(tabNum) {
			this.activeTab = tabNum;
		},
		handleChange(prevIndex, nextIndex) {
			if (prevIndex === 2 && nextIndex === 1) {
				this.nextButtonText = "Next";
			}
			if (prevIndex === 1 && nextIndex === 2) {
				this.nextButtonText = "Save";
			}
			if (prevIndex === 2) {
				this.disbableBottonPrev = false;
			}
		},
		getFormDataCompany(company) {
			this.company = new Company(company);
		},
		getFormDataResource(resource) {
			this.resource = {resource};
		},
		validateStep1() {
			return new Promise((resolve, reject) => {
				this.$validator.validateAll("step-1").then((result) => {
					if (result) {
						if (this.mode === "create") {
							this.$refs.CompanyForm.getDataFormCompany();
						}
						const {valid, invalidFields} = this.company.validateCompany();
						if (valid) {
							resolve(true);
						} else {
							reject("correct all values");
							this.$vs.notify({
								color: "danger",
								title: this.$t("CompanyModule.InvalidFields"),
								text: this.$t(`${invalidFields[0]}`),
							});
						}
					} else {
						reject("correct all values");
						this.$vs.notify({
							color: "danger",
							title: this.$t("CompanyModule.InvalidFields"),
							text: "Todos los campos son requeridos para continuar",
						});
					}
				});
			});
		},
		validateStep2() {
			return new Promise((resolve, reject) => {
				this.$validator.validateAll("step-2").then((result) => {
					if (result) {
						this.$refs.FirstResourceForm.getDataFormResource();
						resolve(true);
					} else {
						reject("correct all values");
						this.$vs.notify({
							color: "danger",
							title: this.$t("CompanyModule.InvalidFields"),
							text: this.$t("ResourceModule.BasicInfoForm.Messages.AllFieldsRequired"),
						});
					}
				});
			});
		},
		validateStep3() {
			return new Promise((resolve, reject) => {
				this.$validator.validateAll("step-3").then((result) => {
					if (result) {
						if (this.company.id > 0) {
							if (this.mode === "update") {
								this.updateData();
							} else {
								this.createAdminResource();
							}
						} else {
							this.createCompany();
						}
						resolve(true);
					} else {
						reject("correct all values");
					}
				});
			});
		},
		validateStep4() {
			return new Promise((resolve, reject) => {
				this.$validator.validateAll("step-4").then((result) => {
					if (result) {
						resolve(true);
					} else {
						reject("correct all values");
					}
				});
			});
		},
	},
	watch: {
		activeTab(val) {
			if (val === 0) {
				this.company = new Company({});
				this.mode = "create";
			}
		},
	},
	created() {
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}
		if (!moduleCompany.isRegistered) {
			this.$store.registerModule("moduleCompany", moduleCompany);
			moduleCompany.isRegistered = true;
		}
	},
};
</script>

<style lang="scss" scoped>
#company-card-main {
	height: 100%;
}
</style>
